import Price from "./Price";
import { withModel } from "../../data-providers/model";

export default withModel(Price);
